import { useMemo } from 'react';
import { NOTIFICATION_STATE } from '../../../NotificationsCenter/config/NotificationState';
import { useNotificationsService } from '../../../NotificationsCenter/hooks/useNotificationsService';
import { CounterBadge } from '../CounterBadge/CounterBadge';

export const NotificationsBadgeCounter = () => {
    const { notifications = [] } = useNotificationsService();
    const notificationsCount = useMemo(
        () => notifications.filter(n => n.state === NOTIFICATION_STATE.NONE).length,
        [notifications]
    );

    return <CounterBadge count={notificationsCount} />;
};
